import PropType from 'prop-types';

export const AnyType = PropType.any;
